<template>
  <div :class="['avatar', modifierSize, modifierBorder]">
    <div class="avatar__wrapper">
      <img
        v-if="img"
        :src="img"
        :alt="name"
        class="avatar__image"
      >
      <abbr
        :title="name"
        class="avatar__initials"
      >
        {{ initials }}
      </abbr>
    </div>
  </div>
</template>


<script>
export default {
  name: 'Avatar',
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'md'
    },
    border: {
      type: Boolean,
      default: false
    },
    img: {
      type: String,
      default: ''
    }
  },
  computed: {
    modifierSize () {
      return `avatar--${this.size}`
    },
    modifierBorder () {
      return this.border ? '' : 'avatar--no-border'
    },
    initials () {
      return this.name
        .split(' ')
        .map(part => part.charAt(0))
        .join('')
        .substring(0, 2)
    }
  }
}
</script>


<style lang="sass">
@import '~styles/imports'

.avatar
  background: $color-grey-2;
  border-radius: 100%;
  border: 1px solid #fff;
  color: $color-white;
  display: block;
  overflow: hidden;

  &--no-border
    border-width: 0;

  &--md
    min-width: rem-calc(42);
    height: rem-calc(42);

    .avatar__initials
      +font-size(16, 16);

  &--48
    min-width: rem-calc(48);
    height: rem-calc(48);

    .avatar__initials
      +font-size(16, 16);

  &--lg
    min-width: rem-calc(100);
    height: rem-calc(100);

    .avatar__initials
      +font-size(48, 48);

  &--xl
    min-width: rem-calc(200);
    height: rem-calc(200);
    border-width: 2px;

    .avatar__initials
      +font-size(100, 100);

  &__wrapper
    padding-bottom: 100%;
    height: 100%;
    width: 100%;
    position: relative;

  &__image
    +z-index('base');
    bottom: 0;
    display: block;
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    border-radius: 100%;

  &__initials
    +z-index('lower-base');
    +font-size(20, 20);

    text-transform: uppercase;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
</style>



// WEBPACK FOOTER //
// src/components/ui/Avatar.vue